import React, { useState, useEffect } from 'react';
import { useMediaQuery, useTheme, PeekButton, PeekStack, PeekSwitch, PeekTypography } from '@piiqtechnologies/ui-components';
import { usePannellumViewer } from '../pannellum-viewer/PannellumProvider.js';
import { getNodeById } from '../pannellum-viewer/pannellumUtils.js';
import { useLoadScene } from '../pannellum-viewer/useNavigateScene.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../../utils/ErrorProvider.js';
import '../../../utils/LoaderProvider.js';
import '../../../utils/RefetchProvider.js';
import '../../../utils/NotificationProvider.js';
import 'tslib';
import '../../../utils/ContactProvider.js';
import '../../../utils/PolicyProvider.js';
import { useAnalytics } from '../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../types/AccessDevice.js';
import '../../../types/Analytics.js';
import '../../../types/CASACommunity.js';
import '../../../types/Community.js';
import '../../../types/DxSettings.js';
import '../../../types/MagicButton.js';
import '../../../types/Pannellum.js';
import '../../../types/Prospect.js';
import '../../../types/ProspectIntelligence.js';
import '../../../types/Space.js';
import '../../../types/Tour.js';
import '../../../utils/analyticsPlugin.js';
import '../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../utils/cookieUtils.js';
import '../../../utils/termsConditionsAgreementsUtils.js';
import { useMultiResConfig } from '../pannellum-viewer/multiresStore.js';

const StagedControl = () => {
    var _a;
    const { getConfig, details, token } = usePannellumViewer();
    const analytics = useAnalytics();
    const { imageId, nodeId } = getConfig();
    const node = getNodeById(details.nodes, nodeId);
    const isStagedImagedLoaded = ((_a = node === null || node === void 0 ? void 0 : node.stagedPhoto) === null || _a === void 0 ? void 0 : _a._id) === imageId;
    const [staged, setStaged] = useState(isStagedImagedLoaded);
    const { loadScene } = useLoadScene();
    const mobileView = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const desktopView = useMediaQuery((theme) => theme.breakpoints.up("md"));
    const theme = useTheme();
    const setCurrentNodeStaged = useMultiResConfig((s) => s.setStaged);
    useEffect(() => {
        setStaged(isStagedImagedLoaded);
    }, [isStagedImagedLoaded]);
    const toggleStagedImage = () => {
        setCurrentNodeStaged(!isStagedImagedLoaded);
        analytics === null || analytics === void 0 ? void 0 : analytics.track("Staged Unstaged Switch");
        node &&
            loadScene({
                node,
                details,
                token: token,
                targetSettings: { pitch: getConfig().pitch, yaw: getConfig().yaw, hfov: getConfig().hfov },
                staged: !isStagedImagedLoaded,
                refresh: true,
            });
    };
    if (!(node === null || node === void 0 ? void 0 : node.stagedPhoto)) {
        return null;
    }
    return (React.createElement(PeekButton, { id: "stage-button", sx: { height: { xs: 40, md: 18, lg: 22 }, width: { xs: 38, md: 84 }, px: { xs: 1, md: 0 } }, onClick: toggleStagedImage },
        React.createElement(PeekStack, { alignItems: "center", direction: { xs: "column", md: "row-reverse" }, spacing: { xs: 0.4, md: 0.64, lg: 0.8 } },
            React.createElement(PeekSwitch, { color: "secondary", size: "medium", inputProps: { "aria-label": (staged && "Staged Room") || "Unstaged Room" }, checked: staged, value: "staged", sx: {
                    "& .MuiSwitch-switchBase": {
                        "&.Mui-checked": {
                            "& + .MuiSwitch-track": {
                                backgroundColor: theme.palette.secondary.main,
                            },
                        },
                    },
                } }),
            React.createElement(PeekTypography, { color: "text.secondary", alignSelf: "center", variant: (mobileView && "body1") || (desktopView && "h3") || "h4" }, "Stage"))));
};

export { StagedControl, StagedControl as default };
